"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const feedback_entity_1 = require("./feedback.entity");
const feedback_service_1 = require("./feedback.service");
const feedback_controller_1 = require("./feedback.controller");
const notifications_module_1 = require("../notifications/notifications.module");
let FeedbackModule = class FeedbackModule {
};
exports.FeedbackModule = FeedbackModule;
exports.FeedbackModule = FeedbackModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([feedback_entity_1.Feedback]), notifications_module_1.NotificationsModule],
        providers: [feedback_service_1.FeedbackService],
        controllers: [feedback_controller_1.FeedbackController],
        exports: [feedback_service_1.FeedbackService],
    })
], FeedbackModule);
